module.exports = __webpack_public_path__ + "static/manage-1b017e1c4fe416a30a40deadfd9489cf.png";